import React from 'react'
import { client2 } from '../../operationalRequest'
import { Switch, Table } from 'antd'
import type { ColumnsType } from 'antd/es/table'

type ControlDeviceProps = {
  value: any
}

const ControlDevice: React.FC<ControlDeviceProps> = ({ value }) => {
  const [loading, setLoading] = React.useState(false)
  const [tableData, setTableData] = React.useState<any[]>([])

  const onChange = async (checked: boolean) => {
    try {
      await client2.post(`api/device/change-status/${value.id}`, { status: checked })
    } catch (e: any) {
      console.error('Error changing status:', e)
    }
  }

  const fetchData = async () => {
    try {
      const response = await client2.get(`api/system-device/mqtt/${value.id}`)
      if (response.status === 200) {
        const parsed = response.data.map((item: any) => {
          return {
            key: item.id,
            topic: item.topic,
            message: item.message,
            created_at: item.created_at,
          }
        })
        setTableData(parsed)
      }
    } catch (error) {
      console.error('Error fetching device data:', error)
    }
  }

  React.useEffect(() => {
    fetchData()
  }, [])

  const columns: ColumnsType<any> = [
    {
      title: 'Topic',
      dataIndex: 'topic',
      key: 'topic',
    },
    {
      title: 'Message',
      dataIndex: 'message',
      key: 'message',
      render: (text: string) => <pre style={{ whiteSpace: 'pre-wrap' }}>{text}</pre>,
    },
    {
      title: 'Created At',
      dataIndex: 'created_at',
      key: 'created_at',
    },
  ]

  return (
    <div>
      <Switch defaultChecked={value?.attributes?.status} onChange={onChange} />
      <Table
        columns={columns}
        dataSource={tableData}
        loading={loading}
        pagination={{ pageSize: 5 }}
      />
    </div>
  )
}

export default ControlDevice
